module.exports = [{
      plugin: require('/Users/guidovanbeek/Projects/experiments/gatsby-site/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/guidovanbeek/Projects/experiments/gatsby-site/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography"},
    },{
      plugin: require('/Users/guidovanbeek/Projects/experiments/gatsby-site/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
